// Modules
import styled from 'styled-components'

export const Content = styled.div`
    text-align: center;
    margin-bottom: 52px;

    & > p:first-child {
        margin-bottom: 24px;
    }
`
